import React from 'react';
import { IconProps } from '.';

const SvgZdsDelivery = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 32 32'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M17.75 7.25H5.25v15.5h2.509a3.5 3.5 0 0 0 6.982 0h3.268a3.5 3.5 0 0 0 6.982 0h1.759v-7.484l-3.802-4.016H17.75v-4Zm0 5.5v8.5h.48a3.501 3.501 0 0 1 6.54 0h.48v-5.386l-2.948-3.114H17.75Zm-1.5-4h-9.5v12.5h1.23a3.501 3.501 0 0 1 6.54 0h1.73V8.75Zm-3 13.75a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm8.25 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgZdsDelivery;
